import Comment from './Comment';
export { default as NewComment } from './NewComment';
export { default as CommentSection } from './CommentSection';
export default Comment;
